// Components
import Vue from 'vue'
import { store } from '../store'
import api from '@/_api'

let localApp = new Vue({})
localApp.store = store

let ui = {
  Confirmacao: function (mensagem, callbackSim, callbackNao, titulo, sim, nao) {
    localApp.store.commit('confirmacao', { titulo: titulo, mensagem: mensagem, sim: sim, nao: nao, show: true })
    var unwatch = localApp.store.watch(() => localApp.store.getters.confirmacao.show, function (newVal, oldVal) {
      unwatch()
      if (!newVal) {
        if (callbackSim && localApp.store.getters.confirmacao.retorno) {
          callbackSim()
        } else if (callbackNao) {
          callbackNao()
        }
      }
    })
  },
  Mensagem: function (tipo, mensagem, callback, titulo, ok) {
    localApp.store.commit('mensagem', { tipo: tipo, titulo: titulo, mensagem: mensagem, ok: ok, show: true })
    var unwatch = localApp.store.watch(() => localApp.store.getters.mensagem.show, function (newVal, oldVal) {
      unwatch()
      if (!newVal && callback) {
        callback()
      }
    })
  },
  Close: function (retorno) {
    localApp.store.getters.mensagem.retorno = retorno
    localApp.store.commit('closeMessage')
  },
  Confirm: function () {
    localApp.store.getters.confirmacao.retorno = true
    localApp.store.commit('close')
  },
  Recuse: function () {
    localApp.store.getters.confirmacao.retorno = false
    localApp.store.commit('close')
  },
  ShowError: function (title, message) {
    localApp.$notify({
      group: 'notifications-default',
      type: 'danger bg-danger text-white',
      title: title || 'Erro',
      text: message.replace(/['"]+/g, '').replace(/\\n/g, '<br/>').replace('\r\n', '<br/>'),
      duration: -1
    })
  },
  ShowAlert: function (title, message) {
    localApp.$notify({
      group: 'notifications-default',
      type: 'warning bg-warning text-white',
      title: title,
      text: message.replace(/\n/g, '<br/>').replace('\r\n', '<br/>')
    })
  },
  ShowInfo: function (title, message) {
    localApp.$notify({
      group: 'notifications-default',
      type: 'bg-secondary text-white',
      title: title,
      text: message.replace(/\n/g, '<br/>').replace('\r\n', '<br/>'),
      duration: -1
    })
  },
  ShowSuccess: function (title, message) {
    localApp.$notify({
      group: 'notifications-default',
      type: 'bg-sucess text-white',
      title: title || 'Sucesso',
      text: message.replace(/\n/g, '<br/>').replace('\r\n', '<br/>')
    })
  },
  FormValidate: function (th) {
    var validator = null
    if (th && th.$refs && th.$refs.form) { validator = th.kendoValidator }

    if (validator) {
      var multiselects = th.$refs.form.querySelectorAll('div.multiselect[required=\'required\']:not([disabled]):not(.multiselect--disabled)')
      for (let i = 0; i < multiselects.length; i++) {
        var item = multiselects[i]
        var input = item.querySelector('input.multiselect__input')
        input.setAttribute('required', true)
        input.value = input.getAttribute('value')
        input.parentElement.setAttribute('aria-labelledby', item.parentElement.getAttribute('aria-labelledby'))
      }

      var msg = []
      var elements = []

      for (let i = 0; i < th.$refs.form.elements.length; i++) {
        elements.push(th.$refs.form.elements[i])
      }
      if (validator.validate()) {
        msg = this.ValidateTipos(elements, msg)
      } else {
        var forms = th.$refs.form.querySelectorAll('form')
        if (forms.length > 0) {
          for (let i = 0; i < forms.length; i++) {
            var formAux = forms[i]
            for (let j = 0; j < formAux.elements.length; j++) {
              elements.push(formAux.elements[j])
            }
          }
        }
        msg = this.ValidateTipos(elements, msg)
      }
    }

    if (msg === undefined) msg = []

    if (msg.length) ui.ShowError('Formulário Inválido', msg.join('<br/>'))
    return !msg.length
  },
  ValidateTipos (elements, msg) {
    for (let i = 0; i < elements.length; i++) {
      let item = elements[i]

      if (item.validity && !item.validity.valid) {
        var label = document.getElementById(item.parentElement.getAttribute('aria-labelledby'))
        if (!label) { label = document.getElementById(item.closest('[aria-labelledby]').getAttribute('aria-labelledby')) }

        label = label ? label.textContent : ''
        if (item.validity.badInput) { msg.push('"' + label + '": o valor informado é inválido!') }
        if (item.validity.customError) { msg.push('"' + label + '" ' + item.validationMessage) }
        if (item.validity.patternMismatch) { msg.push('"' + label + '": o valor informado é inválido!') }
        if (item.validity.rangeOverflow) { msg.push('"' + label + '": o valor informado está Acima do permitido!') }
        if (item.validity.rangeUnderflow) { msg.push('"' + label + '": o valor informado está Abaixo do permitido!') }
        if (item.validity.tooLong) { msg.push('"' + label + '": o valor informado é muito longo!') }
        if (item.validity.tooShort) { msg.push('"' + label + '": o valor informado é muito curto!') }
        if (item.validity.typeMismatch) { msg.push('"' + label + '": o valor informado é inválido!') }
        if (item.validity.valueMissing) { msg.push('"O campo ' + label + '" é obrigatório!') }
      } else {
        if (item.getAttribute('data-role') === 'datepicker') {
          if (item.value) {
            if (!kendo.parseDate(item.value)) {
              let label = document.getElementById(item.closest('[aria-labelledby]').getAttribute('aria-labelledby'))
              msg.push('"' + label.textContent + '": o valor informado é inválido!')
            }
          }
        }
      }
    }
    return msg
  },
  PostAction: function (response, mensagem, showSucessMessage = true) {
    ui.HideLoading()

    if (response && response.pendenteAprovacao === true) {
      ui.PendenteAprovacaoAlcada(response)
      return false
    }

    if (response.error) {
      ui.ShowError('Erro', response.error)
      return false
    }

    if (response.errors && response.errors.length > 0) {
      if (response.errors[0].detail) {
        ui.ShowError('Erro', response.errors[0].detail)
        return false
      }
      ui.ShowError('Erro', response.errors[0])
      return false
    }

    if (response.errors && !response.errors.length) {
      ui.ShowError('Erro', JSON.stringify(response.errors))
      return false
    }

    if (!response.sucesso && response.mensagem) {
      ui.ShowError('Erro', response.mensagem)
      return false
    }

    if (showSucessMessage) {
      if (mensagem != undefined && mensagem != '') {
        ui.ShowSuccess('Sucesso', mensagem)
      } else if (response.mensagem == null || response.mensagem == '') {
        ui.ShowSuccess('Sucesso', 'Operação Realizada com Sucesso!')
      } else {
        ui.ShowSuccess('Sucesso', JSON.stringify(response.mensagem))
      }
    }
    return true
  },
  CustomPostAction: (response) => {
    ui.HideLoading()
    const tipoResponse = api.Enums.TipoResponseContextoCadastros

    if (response.tipoMensagem === tipoResponse.Alerta) {
      ui.ShowAlert(response.titulo || 'Atenção', response.mensagem || '')
      return true
    }

    if (response.tipoMensagem === tipoResponse.Sucesso) {
      ui.ShowSuccess(response.titulo || 'Sucesso', response.mensagem || 'Operação Realizada com Sucesso!')
      return true
    }

    ui.ShowError(response.titulo || 'Erro', response.mensagem || 'Ocorreu um erro na requisição')
    return false
  },
  PostLoadData: function (response) {
    ui.HideLoading()
    if (response.error) {
      ui.ShowError('Erro', response.error)
      return false
    } else if (response.errors && response.errors.length > 0) {
      ui.ShowError('Erro', response.errors[0])
      return false
    } else if (response.errors && !response.errors.length) {
      ui.ShowError('Erro', JSON.stringify(response.errors))
      return false
    } else if (!response.sucesso && response.mensagem) {
      ui.ShowError('Erro', JSON.stringify(response.mensagem))
      return false
    } else {
      return true
    }
  },
  ShowLoading: function () {
    localApp.store.commit('loading', true)
  },
  HideLoading: function () {
    localApp.store.commit('loading', false)
  },
  Redirect: function (that, path, data) {
    that.$router.push({
      path: path,
      query: { data: JSON.stringify(data) }
    })
  },
  GetRequest: function (that) {
    return that.$route.query.data ? JSON.parse(that.$route.query.data) : { value: null }
  },
  ValidaRolePerfilOperador: function (TipoPerfilOperador) {
    let result = false
    const jsonRoles = JSON.parse(localStorage.getItem('user')).roles

    if (!Array.isArray(jsonRoles)) {
      result = api.Arrays.TipoPerfilOperador[jsonRoles] === TipoPerfilOperador
    } else {
      jsonRoles.forEach(e => {
        if (api.Arrays.TipoPerfilOperador[e] === TipoPerfilOperador) {
          result = true
        }
      })
    }

    return result
  },
  PendenteAprovacaoAlcada: function (response, callback) {
    if (!response || response.pendenteAprovacao !== true) return false

    ui.HideLoading()

    const moeda = v =>
      v === null || v === undefined
        ? ''
        : Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    const tipo = (api.Arrays.TipoOperacaoAlcada || []).find(o => o.value === response.tipoOperacao)

    const linhas = [
      'A transação foi <b>enviada para aprovação</b>.',
      tipo ? `<b>Operação:</b> ${tipo.text}` : null,
      `<b>Valor:</b> ${moeda(response.valor)}`,
      response.codigoAprovacaoBackoffice ? `<b>Protocolo:</b> ${response.codigoAprovacaoBackoffice}` : null,
      'Nenhum valor foi debitado e nenhum comprovante foi gerado. A transação só será efetivada após a aprovação.'
    ].filter(l => l !== null)

    const html = '<div class="col-12">' + linhas.map(l => `<p class="mb-2">${l}</p>`).join('') + '</div>'

    ui.Mensagem('alerta', html, callback, 'Enviado para aprovação')
    return true
  },
  Format: {
    Date: '{0:dd/MM/yyyy}',
    DateTime: '{0:dd/MM/yyyy HH:mm:ss}',
    Currency: '{0:c}',
    Integer: '{0}',
    Decimal: '{0:n}',
    Capitalizar (palavra) {
      return palavra ? palavra.charAt(0).toUpperCase() + palavra.slice(1) : ''
    },
    DocumentoFederal: function (value) {
      if (!value) return ''

      const raw = value.toString().toUpperCase()
      const cleanValue = raw.replace(/[^A-Z0-9*]/g, '')

      if (cleanValue.length === 11) {
        return cleanValue.replace(
          /([0-9*]{3})([0-9*]{3})([0-9*]{3})([0-9*]{2})/,
          '$1.$2.$3-$4'
        )
      }

      if (cleanValue.length >= 12 && cleanValue.length <= 14) {
        const padded = cleanValue.padStart(14, '0')

        return padded.replace(
          /([A-Z0-9*]{2})([A-Z0-9*]{3})([A-Z0-9*]{3})([A-Z0-9*]{4})([0-9]{2})/,
          '$1.$2.$3/$4-$5'
        )
      }

      return ''
    },
    Celular: function (value) {
      if (value) {
        value = value.toString().replace(/[^0-9]/g, '')
        const regex = /([0-9]{2})([0-9]{4})([0-9]{1})?([0-9]{4})/
        const subst = '\($1\) $2$3-$4'

        return value.replace(regex, subst)
      }
      return ''
    },
    Telefone: function (value) {
      if (value) {
        value = value.toString().replace(/[^0-9]/g, '')
        const regex = /([0-9]{2})([0-9]{4})([0-9]{1})?([0-9]{4})/
        const subst = '\($1\) $2$3-$4'

        return value.replace(regex, subst)
      }
      return ''
    },
    SomenteNumeros: function (value) {
      if (value) { return value.replace(/[^0-9]/g, '') }
      return ''
    },
    RemoveEspeciaisDocumentoFederal: function (value) {
      if (value) { return value.replace(/[^a-zA-Z0-9]/g, '') }
      return ''
    },
    LinhaDigitavel: function (value) {
      if (value) {
        value = value.toString().replace(/[^0-9]/g, '')
        const regex = /([0-9]{5})([0-9]{5})([0-9]{5})([0-9]{6})([0-9]{5})([0-9]{6})([0-9]{1})([0-9]{14})/
        const subst = '$1.$2.$3.$4.$5.$6.$7.$8'

        return value.replace(regex, subst)
      }
      return ''
      // "'#####.#####.#####.######.#####.######.#.##############'"
    },
    LeftPadNumbers: function (value, totalWidth, paddingChar = '0') {
      if (value == null || value == '') { return '' }
      return value.padStart(totalWidth, paddingChar)
    },
    Cep: function (value) {
      if (value) {
        value = value.toString().replace(/[^0-9]/g, '')
        if (value.length === 8) {
          const regex = /([0-9]{2})([0-9]{3})([0-9]{3})/
          const subst = '$1.$2-$3'
          return value.replace(regex, subst)
        }
      }
      return ''
    },
    removeAcentos (text) {
      text = text.toLowerCase()
      text = text.replace(new RegExp('[ÝÀÂÃ]', 'gi'), 'a')
      text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e')
      text = text.replace(new RegExp('[ÝÌÎ]', 'gi'), 'i')
      text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o')
      text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u')
      text = text.replace(new RegExp('[Ç]', 'gi'), 'c')
      return text
    },
    ContaPgto: (value) => {
      if (value) {
        const regex = /([0-9]+)([0-9]{1})/
        const subst = '$1-$2'
        return value.replace(regex, subst)
      } else return ''
    },
    Dinheiro: (value) => value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }),
    NumeroRegistroCNH: function (value) {
      if (value) {
        value = value.toString().replace(/[^0-9\\*]/g, '')
        if (value.length === 11) {
          const regex = /([0-9\\*]{3})([0-9\\*]{3})([0-9\\*]{3})([0-9\\*]{2})/
          const subst = '$1 $2 $3 $4'
          return value.replace(regex, subst)
        }
      }
      return ''
    },
    NumeroRNE: function (value) {
      if (value) {
        value = value.toString().replace(/[^a-zA-Z0-9\\*]/g, '')
        if (value.length === 8) {
          const regex = /([a-zA-Z0-9\\*]{7})([a-zA-Z0-9\\*]{1})/
          const subst = '$1-$2'
          return value.replace(regex, subst)
        }
      }
      return ''
    }
  },
  Parse: {
    Decimal: function (value) {
      return kendo.toString(value, 'n')
    },
    DateTime: function (value) {
      return new Date(value).toLocaleString().replace(',', '')
    },
    DateTime24: function (value) {
      return new Date(value).toLocaleString('pt-BR', { hour12: false }).replace(',', '')
    },
    // ISO8601 to INT (hours)
    DateTimeISO8601ToHours: function (duration) {
      const match = duration.match(/PT(\d+)H/)
      return match ? Number(match[1]) : 0
    }
  },
  Template: {
    DocumentoFederal: function (e, nomeCampo) {
      if (!nomeCampo) { nomeCampo = 'documentoFederal' }

      var value = e[nomeCampo]
      return ui.Format.DocumentoFederal(value)
    },
    Celular: function (e, nomeCampo) {
      if (!nomeCampo) { nomeCampo = 'telefoneCelular' }

      var value = e[nomeCampo]
      return ui.Format.Celular(value)
    },
    Telefone: function (e, nomeCampo) {
      if (!nomeCampo) { nomeCampo = 'telefone' }

      var value = e[nomeCampo]
      ui.Format.Telefone(value)
    },
    GetListText: function (e, nomeCampo, lista, value, text) {
      if (e && e[nomeCampo]) {
        if (!value) { value = 'value' }
        if (!text) { text = 'text' }
        var list = lista.filter(p => p[value] == e[nomeCampo])
        return list[0][text]
      }
      return ''
    },
    ValorContabil: function (e, campoValor, campoOperacao) {
      var valor = e[campoValor]
      var operacao = e[campoOperacao]
      e[campoValor] = ui.Parse.Decimal(valor) + ' ' + (operacao === 'D' ? '-' : (operacao === 'C' ? '+' : ''))
      return e[campoValor]
    },
    ContaPgto: (e, nomeCampo) => {
      if (!nomeCampo) { nomeCampo = 'contaPgto' }
      var value = e[nomeCampo]
      return ui.Format.ContaPgto(value)
    },
    Decimal: (e, nomeCampo) => {
      if (!nomeCampo) { nomeCampo = 'valor' }
      var value = e[nomeCampo]
      return ui.Format.Dinheiro(value)
    },
    CheckAll:
      ' <div class="custom-control custom-checkbox">' +
      '   <input type="checkbox" autocomplete="off" class="custom-control-input custom-grid-checkbox" value="true" id="check_all">' +
      '   <label class="custom-control-label" for="check_all">' +
      '   </label>' +
      ' </div>'
  },
  Date: {
    DataAtual: function () {
      return kendo.date.today()
    },
    PrimeiroDiaMes: function (date) {
      return kendo.date.firstDayOfMonth(date)
    },
    UltimoDiaMes: function (date) {
      return kendo.date.lastDayOfMonth(date)
    },
    AddDay: function (date, dias) {
      return kendo.date.addDays(date, dias)
    },
    AddMonth: function (date, meses) {
      meses = date.getMonth() + meses
      date.setMonth(meses)
      return date
    },
    AddYear: function (date, anos) {
      anos = date.getFullYear() + anos
      date.setYear(anos)
      return date
    }
  },
  Validate: {
    ValidarGuid (value) {
      var pattern = new RegExp('[0-9a-f]{8}([-]{0,1}[0-9a-f]{4}){3}[-]{0,1}([0-9a-f]{12})', 'im')
      if (pattern.test(value)) return true
      else return false
    },
    ValidarCPF (value) {
      if (!value) return false

      const cpf = value.toString().replace(/[^0-9]/g, '')
      let sum = 0
      let remainder

      if (
        cpf.length !== 11 ||
        cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999'
      ) {
        return false
      }

      for (let i = 1; i <= 9; i++) sum += parseInt(cpf.charAt(i - 1)) * (11 - i)
      remainder = (sum * 10) % 11

      if (remainder === 10 || remainder === 11) remainder = 0
      if (remainder !== parseInt(cpf.charAt(9))) return false

      sum = 0
      for (let i = 1; i <= 10; i++) sum += parseInt(cpf.charAt(i - 1)) * (12 - i)
      remainder = (sum * 10) % 11

      if (remainder === 10 || remainder === 11) remainder = 0
      return remainder === parseInt(cpf.charAt(10))
    },
    ValidarCNPJ (value) {
      const pattern = /^[A-Z0-9]{2}([.]?[A-Z0-9]{3}){2}\/?[A-Z0-9]{4}-?[0-9]{2}$/i
      return pattern.test(value)
    },
    ValidarCelular (value) {
      if (!value) return false

      let onlyNumbers = value.toString().replace(/[^0-9]/g, '')
      if (onlyNumbers.length > 11 && onlyNumbers.startsWith('55')) {
        onlyNumbers = onlyNumbers.substring(2)
      }

      return /^(\d{2})(9\d{8}|\d{8})$/.test(onlyNumbers)
    },
    ValidarCelularComEspaco (value) {
      var pattern = /\+?(55)?\(?[0-9]{2}\)?\s?[0-9]{5}\-?[0-9]{4}/g

      return pattern.test(value)
    },
    ValidarEmail (value) {
      var pattern = new RegExp('[a-z0-9]+@[a-z]+\..\.[a-z]{2,3}', 'g')
      if (pattern.test(value)) return true
      else return false
    },
    ValidarInteiro (value, maxLength) {
      value = value.toString()

      var pattern = new RegExp('[^0-9]')

      return (!pattern.test(value) && value.length <= maxLength)
    }
  }
}

export default ui
